module.exports = __webpack_public_path__ + "img/7.2mi.877dbfd4.png";